import Dexie from "dexie";

export const db = new Dexie('VendMais');

export const dbCep = new Dexie('VendMaisCep');

dbCep.version(2).stores({
  cep: 'id, cep, cidadeId'
});

db.version(134).stores({
  cliente: 'id, clienteProspect, clienteCarteira, recebedor, razaoSocial',
  reflex: "++id,nome",
  posicaoCarga: "++id",
  parametroReflex: '++id,nome',
  prospect: 'id, clienteProspect, clienteCarteira, razaoSocial',
  token: 'id',
  buscaOnline: 'id',
  solicitacoes: 'id',
  canaisDistribuicao: 'id',
  embalagens: 'id',
  empresas: 'id',
  familiaProdutos: 'id, codigo, grupoMaterialId',
  filiais: 'id',
  grupoCentralizador: 'id',
  grupoProdutos: 'id',
  trilhas: 'id',
  grupoSegmento: 'id, trilhaId',
  segmento: 'id, grupoSegmentoId',
  unidadeMedidas: 'id',
  prazoPagamento: 'id',
  motivo: 'id',
  local: 'id',
  localTrilha: 'id',
  contexto: 'id',
  parametros: 'id, slug',
  produtos: 'id, grupoMaterialId',
  precoProduto: 'id, produtoId, filialId, microrregiaoId',
  servico: 'id, microrregiaoId, familiaId',
  mapaDaMina: 'id, clienteId, pesquisaProdutoId',
  mapaDaMinaNaoIds: 'id, clienteId',
  mapaDaMinaOriginal: 'id, clienteId',
  mapaDaMinaClienteFechado: "clienteId",
  mapaDaMinaFiltros: "clienteId",
  documentos: 'id, documento',
  ultimosUploadsDocumentos: 'id',
  tipoCondicao: 'id',
  pesquisaMedidas: 'id',
  pesquisaPrazos: 'id, ordem',
  pesquisaProdutos: 'id, pesquisaGrupoMaterialId',
  pesquisaPlayers: 'id',
  pesquisaGrupoMaterial: 'id',
  pesquisaCentroOrigem: 'id',
  pesquisaEmbalagem: 'id',
  pesquisaCanalDistribuicao: 'id',
  pesquisaMotivoCompra: 'id',
  pesquisaGrupoMaterialCanalDistribuicao: 'id, pesquisaGrupoMaterialId, pesquisaCanalDistribuicaoId',
  pesquisaGrupoMaterialEmbalagem: 'id, pesquisaGrupoMaterialId, pesquisaEmbalagemId',
  pesquisaGrupoMaterialUnidadeMedida: 'id, pesquisaGrupoMaterialId, pesquisaUnidadeMedidaId',
  pesquisaGrupoMaterialPlayer: 'id, pesquisaGrupoMaterialId, pesquisaPlayerId',
  pesquisaGrupoMaterialPrazo: 'id, pesquisaGrupoMaterialId, pesquisaPrazoId',
  pesquisaGruposObrigatorios: 'id, pesquisaGrupoMaterialId, trilhaId',
  pesquisaPlayerCentroOrigem: 'id, pesquisaPlayerId, pesquisaCentroOrigemId',
  pesquisaCampoCliente: 'id, clienteId', //GESTÃO DE PESQUISA
  cidades: 'id, nome, estadoId, estado.sigla',
  estados: 'id, nome, sigla',
  simulacoes: 'id, simulacaoId, clienteId',
  simuladorSimulacoes: 'id, clienteId',
  hierarquiasAprovacao: 'id',
  usuario: 'id',
  vendedores: 'id',
  vendedorSelecionado: 'id',
  produtoFilialMicro: "id, produtoId, filialId, grupoMaterialId",
  perfis: 'id, nome, slug, funcoes',
  perfilFuncoes: 'id, perfilId, funcaoId',
  tabelaPreco: 'id, nomeFilial, [produtoId+filialId+microrregiaoId]',
  precosCliente: 'id, vigenciaTimestamp, clienteId, clienteNome, proximaVencimento, faixaF',
  negociacaoPrecoRegra: 'id, clienteId',
  motivosComerciais: 'id, descricao',
  produtosFiliais: 'id, produtoId, filialId',
  niveisServico: 'id',
  motivosPerda: 'id',
  funilObra: '++id, clienteId',
  funilObraNaoSalvo: '++id, clienteId',
  funilObraDashboard: '++id, clienteId, dataNegociacao',
  obraAtiva: 'id',
  obraAtivaFormatada: 'id',
  subGrupoMaterial: 'id, grupoMaterialId',
  sincronizacao: 'id, table',
  funilObraGrupoProdutos: 'id',
  funilObraProdutos: 'id, funilObraGrupoProdutoId',
  funilObraJustificativas: 'id',
  funilObraUnidadeMedidas: 'id,nome',
  funilObraGrupoProdutoUnidadeMedida: 'id, funilObraGrupoProdutoId, funilObraUnidadeMedidaId',
  funilObraMotivoPerda: 'id',
  produtosConcorrente: 'id',
  prazoRegra: 'id',
  cargos: 'id',
  cluster: 'id',
  microrregiao: 'id',
  funilStatus: 'id, ordem',
  funilStatusGrupo: 'id, prioridade',
  ordenacaoTabelaPreco: 'id, sequencia',
  tabelaPrecoCliente: 'id, sequencia',
  rotas: 'id, dataLabel, sequencia',
  infosTatica: 'id, clienteId',
  missoes: 'id, clienteId',
  faturamentos: 'id, clienteId',
  visitaAtiva: 'id',
  visitas: 'id, clienteId, dataLabel, data',
  ultimaVisita: 'id',
  tabelaSolicitacoes: 'id, clienteId, data',
  funilObraConcorrente: 'id',
  funilObraGrupoProdutoMapeamentoInicial: 'id',
  funilObraConsorcio: 'id',
  funilObraEmpresasLider: 'id',
  funilObraFonteCaptacao: 'id',
  govs: 'id, clienteId',
  pendingRequests: '++id,method,apiName,endpoint,data',
  equipesVenda: 'id',
  escritoriosVenda: 'id',
  areasVendaVendedor: 'id',
  duplaCategoria: 'id',
  missoesStatus: 'id, missoes, data',
  autosservico: '++id',
  creditoCliente: '++id',
  forcaVenda: '++id',
  erroPesquisa: '++id',
  erroPesquisaVendedor: '++id',
  bateuLevou: '++id',
  super4: '++id',
  vloz: '++id',
  passouGanhou: '++id',
  gvFaturamento: '++id',
  clienteShare: '++id'
});

// Gerenciamento de erros durante as operações
db.on('versionchange', () => {
  localStorage.removeItem('last-fetch-datetime-new');
  db.delete();
  window.location.reload();
});

db.open().catch(async (err) => {
  if (
    err.name === 'UpgradeError' ||
    err.name === 'DatabaseClosedError' ||
    err.name === 'VersionError'
  ) {
    console.warn('Banco local incompatível, recriando...', err);
    await Dexie.delete('VendMais');
    window.location.reload();
  }
});